<template>
    <div v-if="statsVisibility" class="product-stats">
        <g-typography tag="h4" color="secondary" :value="`${counterPrefix} Selected`" />
        <g-typography
            v-if="priceLimitEnabled"
            tag="h4"
            color="secondary"
            :value="`Remaining Funds: ${remainingAmount}`"
        />
    </div>
</template>

<script>
    import { get } from 'lodash';
    import ActivationBriefProductConfigMixin from '../../mixins/ActivationBriefProductConfigMixin';
    import ActivationBriefProductsMixin from '../../../../providers/mixins/ActivationBriefProductsMixin';
    import { formatCurrency } from '../../../../../helpers/formatters';

    export default {
        name:   'ProductStats',
        mixins: [
            ActivationBriefProductsMixin,
            ActivationBriefProductConfigMixin,
        ],
        props: {
            selection: {
                type:     Array,
                required: true,
            },
        },
        computed: {
            /* These stats do not show up on preselected selection method */
            statsVisibility() {
                return !this.selectionMethodPreselected && this.brief.activation.has_module_products;
            },

            /* `3 Selected` form for `unlimited` selection method, `0/2 Selected` form for other selection methods */
            counterPrefix() {
                if (this.selectionMethodUnlimited) {
                    return this.productsSelected;
                } else {
                    return `${this.productsSelected}/${this.productConfig.quantity_limit}`;
                }
            },

            /* Price limit minus all product totals */
            remainingAmount() {
                const priceSelections = this.selection.map((item) => {
                    const product = this.readStore(item.id);
                    const variant = item.variant_id ? product.variants.find((variant) => item.variant_id === variant.id) : null
                    return variant ? variant.price : product.price;
                });

                const productTotal = priceSelections.reduce((acc, price) => acc + price, 0);

                return formatCurrency(
                    this.productConfig.price_limit - productTotal,
                    get(this, 'brief.brand.currency', 'usd')
                );
            },

        },
    };
</script>

<style lang="scss" scoped>
.product-stats {
    margin-top: $g-spacing-5;
    margin-bottom: $g-spacing-5;
    padding-top: $g-spacing-5;
    display: flex;
    justify-content: space-between;
}
</style>
